import React from "react";
import styles from "./OIDC.module.scss";
import classnames from "classnames";

const onFB = () => {
	if (localStorage.auth) {
		window.location.href = "/dashboard";
	} else {
		window.location.href = "/api/continue-with-facebook"
	}
}

const fbclasses = classnames(styles["loginBtn"], styles["loginBtn--facebook"]);
const gclasses = classnames(styles["loginBtn"], styles["loginBtn--google"]);

export const Facebook = () => (
	<button onClick={onFB} className={fbclasses} >
		Continue with Facebook
	</button>
);

export const Google  = () => (
	<button className={gclasses}>
		Login with Google
	</button>
);
